import SubscriptionProvider from '../enums/SubscriptionProvider';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logPurchasePlatformRedirectParams = {
  original_provider: SubscriptionProvider;
};

/**
 * User is redirected to a specific platform for upgrading their subscription.
 * @param params - Attributes to log with the amplitude event
 * @param params.original_provider - The subscription provider currently associated with the user's subscription.
 */
const logPurchasePlatformRedirect = ({ original_provider }: logPurchasePlatformRedirectParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('purchase platform redirect', { 'original provider': original_provider }, callback);
};

export default logPurchasePlatformRedirect;
